import { ForEachNodeDataSchema, parseNodeDataWithSchema } from '@cotera/api';
import type { WorkflowNodeData } from '../types';
import type { WorkflowNodeHydration } from '../workflow-node-base';
import type { WorkflowNodeOutputShapeContext } from '../workflow-node-output-shape';
import { displayForEachOutputShape, nonBlank } from './output-shape-helpers';
import { TypedWorkflowNode } from './typed-workflow-node';

// Just the body pointer: a malformed `itemsPath` shouldn't hide which node is
// the loop body, or replacing the body would orphan the old one.
const LoopBodySchema = ForEachNodeDataSchema.pick({ childNodeId: true });

export class ForEachWorkflowNode extends TypedWorkflowNode<
  typeof ForEachNodeDataSchema
> {
  protected readonly schema = ForEachNodeDataSchema;

  static override create(
    data: WorkflowNodeData,
    hydration: WorkflowNodeHydration
  ): ForEachWorkflowNode {
    return new ForEachWorkflowNode(data, hydration);
  }

  override loopBodyNodeId(): string | null {
    const parsed = parseNodeDataWithSchema(LoopBodySchema, this._data.data);
    return parsed.t === 'valid'
      ? nonBlank(parsed.data.childNodeId) ?? null
      : null;
  }

  override deriveTypedOutputShape(
    context: WorkflowNodeOutputShapeContext
  ): string | null {
    const bodyNodeId = this.loopBodyNodeId();
    const childShape =
      bodyNodeId !== null ? context.resolveNodeOutputShape(bodyNodeId) : null;
    return displayForEachOutputShape(childShape);
  }

  protected override defaultDisplayName(): string {
    return 'For each';
  }
}
